import React, { useState, useEffect } from "react";
import { Banner } from "./Banner";
import { Footer } from "./Footer";
import Map from "./Map";
import { News } from "./News";
import { Helpline } from "./Helpline";
import Stats from "./Stats";
import Hero from "./Hero";
import Loader from "react-loader-spinner";
import DeltaGraph from "./DeltaGraph";
import covidData from "../data/covid_data.json";

const ShowBanner = (props) => {
  if (props.stateinfo !== null) {
    let indiaConfirmed = 0;
    let indiaDeceased = 0;
    let indiaRecovered = 0;
    let indiaVaccinated = 0;
    props.stateinfo.forEach((el) => {
      indiaConfirmed += (props.obj[el]["total"].confirmed);
      indiaDeceased += (props.obj[el]["total"].deceased);
      indiaRecovered += (props.obj[el]["total"].recovered);
      indiaVaccinated += (props.obj[el]["total"].vaccinated1);
    });
    return <Banner conf={indiaConfirmed / 2} vacc={indiaVaccinated / 2} recov={indiaRecovered / 2} dead={indiaDeceased / 2} />;
  } else return null;
}

const ShowMap = (props) => {
  if (props.stateinfo !== null) {
    let stateConfirmed = [];
    let stateDeceased = [];
    let stateRecovered = [];
    let stateTested = [];
    let stateVaccinated = [];
    props.stateinfo.forEach((el) => {
      stateConfirmed.push(props.obj[el]["total"].confirmed);
      stateDeceased.push(props.obj[el]["total"].deceased);
      stateRecovered.push(props.obj[el]["total"].recovered);
      stateTested.push(props.obj[el]["total"].tested);
      stateVaccinated.push(props.obj[el]["total"].vaccinated1);
    });
    return <Map stateC={stateConfirmed} stateR={stateRecovered} stateD={stateDeceased} tested={stateTested} vaccinated={stateVaccinated} stateinfo={props.stateinfo} />;
  } else return null;
}

export const Main = () => {
  const [obj, setObject] = useState(null);
  const [stateinfo, setStateinfo] = useState(null);
  const [updated, setUpdated] = useState(null);

  useEffect(() => {
    let res = covidData;
    console.log(res);
    setObject(res);
    setStateinfo(Object.keys(res));
    setUpdated(res["MH"]["meta"].last_updated);
  }, []);

  return (
    <div className="main-container">
      <Hero lastUpdated={updated} />
      <ShowBanner stateinfo={stateinfo} obj={obj} />
      <div className="main">
        <div className="stats">
          <Stats header={true} />
          {stateinfo ? (
            stateinfo.map((el, idx) => {
              return (
                <Stats
                  header={false}
                  key={idx}
                  state={el}
                  confirmed={obj[el]["total"].confirmed}
                  deceased={obj[el]["total"].deceased}
                  recovered={obj[el]["total"].recovered}
                  tested={obj[el]["total"].tested}
                  vaccinated={obj[el]["total"].vaccinated1}
                />
              );
            })
          ) : (
            <h3>
              Loading statistics <Loader type="TailSpin" width={80} height={80} color="#0070f3" />
            </h3>
          )}
        </div>
        <div>
          <ShowMap stateinfo={stateinfo} obj={obj} />
          <DeltaGraph stateinfo={obj} />
          <News />
        </div>
      </div>
      <Helpline />
      <Footer />
    </div>
  );
};
